import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { blue, green } from "@material-ui/core/colors";

export default makeStyles((theme: Theme) =>
  createStyles({
    hour: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "end"
    },
    user: {
      marginLeft: 0,
      fontWeight: 700
    },
    value: {
      paddingRight: "0.5rem"
    },
    purchaseAmount: {
      fontWeight: "bold"
    },
    lastPurchase: {
      flexGrow: 1,
      color: theme.palette.primary.dark
    },
    eventType: {
      marginLeft: 0,
      paddingRight: "1rem",

      "& .eventPayment": {
        color: theme.palette.success.dark
      }
    },
    "@keyframes fadeIn": {
      "0%": {
        backgroundColor: "#ffffff"
      },
      "50%": {
        backgroundColor: blue["50"]
      },
      "100%": {
        backgroundColor: "#ffffff"
      }
    },
    openDoor: {
      animation: "$fadeIn 1s linear"
    },
    "@keyframes purchase": {
      "0%": {
        backgroundColor: "#ffffff"
      },
      "50%": {
        backgroundColor: green["50"]
      },
      "100%": {
        backgroundColor: "#ffffff"
      }
    },
    purchase: {
      animation: "$purchase 1s linear"
    },
    userSuspicious: {
      fontSize: "1rem !important",
      color: theme.palette.warning.dark
    },
    userLocked: {
      fontSize: "1rem !important",
      color: theme.palette.error.dark
    }
  })
);
